import React from 'react';



import MainUI from '../../components/main-ui-component/main-ui-component';

const HomePage = () => (
  <div>
    <MainUI />
  </div>
  
)

export default HomePage;